// js/utils/toast.js

class ToastManager {
  constructor() {
    this.container = document.querySelector('.toast-container');
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.className = 'toast-container';
      document.body.appendChild(this.container);
    }
  }

  show(message, type = 'info', duration = 3000) {
    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    
    const text = document.createElement('p');
    text.className = 'toast__message'; 
    // Usamos innerHTML para permitir renderizar los íconos de Tabler
    text.innerHTML = message;

    toast.appendChild(text);
    this.container.appendChild(toast);

    // Auto-destrucción con limpieza de fotogramas
    setTimeout(() => {
      toast.style.animation = 'none';
      requestAnimationFrame(() => {
        toast.classList.add('toast--closing');
        setTimeout(() => {
          toast.remove();
        }, 300);
      });
    }, duration);
  }

  /**
   * Un aviso con una acción al lado — hoy sólo "Deshacer".
   *
   * Dura más que los otros porque hay que alcanzar a leerlo **y** decidir, y arma el texto con
   * `textContent` en vez de `innerHTML`: acá entra el nombre de lo que se acaba de tocar, y ése es
   * el camino por el que un dato del negocio termina interpretado como marcado.
   */
  accion(message, etiqueta, al, duration = 8000) {
    const toast = document.createElement('div');
    toast.className = 'toast toast--info toast--accion';
    const text = document.createElement('p');
    text.className = 'toast__message';
    text.textContent = message;
    const btn = document.createElement('button');
    btn.className = 'toast__accion';
    btn.textContent = etiqueta;
    btn.addEventListener('click', () => { toast.remove(); al(); });
    toast.appendChild(text);
    toast.appendChild(btn);
    this.container.appendChild(toast);
    setTimeout(() => {
      if (!toast.isConnected) return;
      toast.classList.add('toast--closing');
      setTimeout(() => toast.remove(), 300);
    }, duration);
  }

  success(message) { this.show(message, 'success'); }
  error(message) { this.show(message, 'error', 5000); }
  info(message) { this.show(message, 'info'); }
}

export const Toast = new ToastManager();